import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment.local';
import { User, UserAuth } from '../models';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MeActions } from 'app/store/me/me.actions';
import { selectProfileData } from 'app/store/me/me.selectors';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly router: Router = inject(Router);
  private readonly store: Store = inject(Store);

  setUserToken(token: string): void {
    localStorage.setItem('user_access_token', token);
    this.store.dispatch(MeActions.getProfile());
    this.store.dispatch(MeActions.getSettings());
  }

  getUserToken(): string {
    return localStorage.getItem('user_access_token');
  }

  removeUserToken(): void {
    localStorage.removeItem('user_access_token');
  }

  isLogged(): boolean {
    return !!this.getUserToken();
  }

  register(user: UserAuth): Observable<any> {
    return this.http
      .post(environment.api.register, user)
      .pipe(map((res) => res));
  }

  logInSymfony(redirect = null): void {
    const token = this.getUserToken();
    let params = '';
    if (redirect) {
      Object.entries(redirect).forEach(
        ([key, value]) => (params += `&${key}=${value}`)
      );
    }
    this.router.navigate(['/dashboard/']);
  }

  login(user: string, password: string | Int32Array): Observable<any> {
    return this.http
      .post(environment.api.auth, { login: user, md5Pwd: password })
      .pipe(map((res) => res));
  }
}
